<div
  class="irt-primary-medium-background irt-border-radius irt-half-padding"
  style="position: relative">
  <h6
    class="irt-no-margin"
    style="position: absolute; top: -12px; left: 0">
    <u> 05.Patente autista </u>
  </h6>

  <div class="irt-full-width irt-spaced-row">
    <h6 class="irt-no-margin irt-primary-medium-color">NUMERO</h6>
    <h6 class="irt-no-margin">{{ customer.license_num }}</h6>
  </div>

  <div class="irt-full-width irt-spaced-row irt-half-margin-top">
    <h6 class="irt-no-margin irt-primary-medium-color">LUOGO DI RILASCIO</h6>
    <h6 class="irt-no-margin">{{ customer.license_place }}</h6>
  </div>

  <div class="irt-full-width irt-spaced-row irt-half-margin-top">
    <h6 class="irt-no-margin irt-primary-medium-color">DATA DI RILASCIO</h6>
    <h6 class="irt-no-margin">{{ customer.license_date }}</h6>
  </div>

  <div class="irt-full-width irt-spaced-row irt-half-margin-top">
    <h6 class="irt-no-margin irt-primary-medium-color">DATA DI SCADENZA</h6>
    <h6 class="irt-no-margin">{{ customer.license_exp }}</h6>
  </div>
</div>
